import { useState } from "react";
import { Link } from "react-router-dom";
import { faqs } from "@/mocks/faqs";

export default function HomeFaq() {
  const [openId, setOpenId] = useState<string>(faqs[0].id);
  const list = faqs.slice(0, 5);

  const toggle = (id: string) => setOpenId((prev) => (prev === id ? "" : id));

  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto grid w-full max-w-[1240px] grid-cols-1 gap-10 px-4 md:px-6 lg:grid-cols-12 lg:gap-14">
        <div className="lg:col-span-4">
          <div className="mb-2 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
            <span className="h-[2px] w-6 bg-primary-500" aria-hidden="true" />
            FAQ
          </div>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            关于核验，你可能想问
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            这里整理了用户最常提出的问题。如果你的疑问不在其中，欢迎直接联系我们。
          </p>
          <Link
            to="/faq"
            className="mt-6 inline-flex items-center gap-1.5 rounded-md border border-background-300 px-4 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            查看全部问题
            <i className="ri-arrow-right-line text-base" aria-hidden="true" />
          </Link>
        </div>

        <div className="lg:col-span-8">
          <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
            {list.map((item) => {
              const isOpen = openId === item.id;
              return (
                <div key={item.id}>
                  <button
                    type="button"
                    onClick={() => toggle(item.id)}
                    aria-expanded={isOpen}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-5 text-left transition-colors hover:bg-background-100"
                  >
                    <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                      {item.question}
                    </span>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-base transition-colors ${
                        isOpen ? "bg-primary-500 text-white" : "bg-background-100 text-foreground-500"
                      }`}
                      aria-hidden="true"
                    >
                      <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                    </span>
                  </button>
                  {isOpen ? (
                    <div className="px-5 pb-5">
                      <p className="max-w-3xl text-sm leading-relaxed text-foreground-600">{item.answer}</p>
                    </div>
                  ) : null}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}